import { render, staticRenderFns } from "./TemplateManagementDrawer.vue?vue&type=template&id=c80d9274&scoped=true"
import script from "./TemplateManagementDrawer.vue?vue&type=script&lang=ts"
export * from "./TemplateManagementDrawer.vue?vue&type=script&lang=ts"
import style0 from "./TemplateManagementDrawer.vue?vue&type=style&index=0&id=c80d9274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80d9274",
  null
  
)

export default component.exports